export default __webpack_public_path__ + "static/media/request-success.dd402efd.svg";